import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.997 12.25a9 9 0 1 0 -8.718 8.745","key":"svg-0"}],["path",{"d":"M16 19a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M17 21l4 -4","key":"svg-2"}],["path",{"d":"M12 7v5l2 2","key":"svg-3"}]]

const IconClockCancel = createReactComponent('outline', 'clock-cancel', 'ClockCancel', __iconNode);

export default IconClockCancel;